import { Component, inject } from "@angular/core";
import { Router } from "@angular/router";

import { IcEnvironment } from "@intocare-medapp/environment";

@Component({
	selector: "ic-mfa-activation",
	templateUrl: "./mfa-activation.component.html",
	styleUrls: ["./mfa-activation.component.scss"],
	standalone: false,
})
export class MfaActivationComponent {
	private readonly router = inject(Router);
	private readonly icEnvironment = inject(IcEnvironment);

	appVersion = this.icEnvironment.getEnvironment().APP_VERSION;

	submit() {
		this.router.navigate(["select-organisation"]);
	}

	cancel() {
		this.router.navigate(["select-organisation"]);
	}
}
